var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRedStrip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 325.592,
    height: 194.505,
    preserveAspectRatio: "none",
    viewBox: "0 0 325.592 194.505",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "red-strip",
    transform: "translate(-688.844 -86.277)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_33189",
    "data-name": "Group 33189",
    transform: "translate(116.998)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_22",
    "data-name": "Rectangle 22",
    d: "M308.343,0H15.657C7.01,0,0,15.092,0,33.708V151.54l-1.059,38.242C2.379,161,17.7,142.37,40.348,136.146s194.916-2.593,231.851,0c9.234.865,50.594-.067,51.8-54.462V33.708C324,15.092,316.99,0,308.343,0Z",
    transform: "translate(573.002 91)",
    fill: "#edbbc3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_23",
    "data-name": "Rectangle 23",
    d: "M283.455-1.723H-7.675C-21.129,3.612-27.236,10.237-26,34.492v147.69c4-32.224,17.64-42.131,40.2-48.4s193.788-1.737,229.2,0c9.2.871,48.8.339,55.6-56.179V34.492C301.4,11.663,293.594,6.092,283.455-1.723Z",
    transform: "translate(598.002 88)",
    fill: "#f4dfe6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedStrip);
export default __webpack_public_path__ + "static/media/red-strip.5905b4eb02e1d9567bebf84a22956038.svg";
export { ForwardRef as ReactComponent };